import React, { useEffect, useState } from 'react';
import flowRight from 'lodash/flowRight';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import BaseAccessibility from './Accessibility';

export const Accessibility = flowRight(
    // Client-side render this component because cookies are not accessible on the server-side.
    clientSideRender,
    withCustomMetrics({ section: 'Accessibility', component: 'Accessibility' })
)(BaseAccessibility);

export default Accessibility;

/**
 * This HOC causes the wrapped component to only be rendered on the client side.
 */
function clientSideRender(WrappedComponent) {
    return function ClientSideRenderedComponent(props) {
        const [isInitialized, setIsInitialized] = useState(false);
        useEffect(() => {
            setIsInitialized(true);
        }, []);

        return isInitialized ? <WrappedComponent {...props} /> : null;
    };
}
